export const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-white/30">
      <LogoLoader className="size-16" />
    </div>
  )
}

export const InlineLoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center p-4">
      <LogoLoader className="size-8" />
    </div>
  )
}

export function LogoLoader({ className = 'size-20' }: { className?: string }) {
  return (
    <div className="flex flex-col items-center gap-4">
      <svg viewBox="0 0 96 96" role="status" aria-label="Loading" className={className}>
        <circle fill="#0b2948" cx="48" cy="48" r="48" />

        <g className="logo-loader__parts">
          <path
            className="logo-loader__part logo-loader__part--1"
            fill="#fff"
            d="M59.04,30.48c-1.92-5.74-5.79-10.68-10.88-13.93-7.45,4.27-12.98,11.45-15.24,19.77,0,0,12.7-6.69,27.29-.54-.22-1.85-.61-3.63-1.17-5.3Z"
          />

          <path
            className="logo-loader__part logo-loader__part--2"
            fill="#61c9dc"
            d="M32.47,55.54c-1.84-5.49-2.24-11.36-1.15-17.01-7.33,5.11-11.83,13.72-11.8,22.67,5.36,3.45,11.73,4.85,18.02,3.97-2.2-2.9-3.9-6.14-5.07-9.62Z"
          />

          <path
            className="logo-loader__part logo-loader__part--3"
            fill="#fff"
            d="M73.07,52.36c-2.05-6.1-6.17-11.29-11.64-14.66.55,12.26-7.11,23.47-18.78,27.39-.98.33-1.99.59-3.16.83,7.3,8.63,18.69,12.9,29.86,11.17,5.11-7.16,6.5-16.4,3.71-24.72Z"
          />
        </g>
      </svg>
    </div>
  )
}
